var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDestinationCountriesSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.033,
    height: 86.674,
    viewBox: "0 0 82.033 86.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Destination_Countries",
    "data-name": "Destination Countries",
    d: "M82.147,78.448,76.223,60.672h-6.5l3.61,17.335H9.774l3.61-17.335h-6.5L.955,78.448c-1.5,4.524,1.161,8.225,5.928,8.225H76.223C80.99,86.674,83.655,82.973,82.147,78.448ZM63.221,21.668a21.668,21.668,0,0,0-43.337,0c0,20.693,21.668,43.337,21.668,43.337S63.221,42.362,63.221,21.668Zm-33.369.26a11.7,11.7,0,1,1,11.7,11.7,11.7,11.7,0,0,1-11.7-11.7Z",
    transform: "translate(-0.535)",
    fill: "#007cab"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinationCountriesSelected);
export default __webpack_public_path__ + "static/media/DestinationCountries_Selected.1aff051fabe42568ac144db2fdfc88eb.svg";
export { ForwardRef as ReactComponent };